// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PostOuterApiConfigsTestBody,
    BaseResponseOuterApiTestResponseFoundResponse,
} from '../../types';

/**
 * api接口测试
 *
 * @export
 * @tags 语义智能-外部接口配置
 * @link [POST] /outerApiConfigs/test
 */
export function postOuterApiConfigsTest(
    data: PostOuterApiConfigsTestBody
): Promise<BaseResponseOuterApiTestResponseFoundResponse>;
export function postOuterApiConfigsTest(
    data: PostOuterApiConfigsTestBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseOuterApiTestResponseFoundResponse>;
export function postOuterApiConfigsTest(
    data: PostOuterApiConfigsTestBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseOuterApiTestResponseFoundResponse> {
    return request<PostOuterApiConfigsTestBody, never, never>('/outerApiConfigs/test', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postOuterApiConfigsTest',
    });
}

export const meta = [
    { tags: ['语义智能-外部接口配置'], path: '/outerApiConfigs/test', method: 'post' },
];
